<template>
  <div class="card">
    <div class="card-header">
      <div class="card-title d-flex align-items-center">
        <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
          <inline-svg src="media/icons/duotune/ecommerce/ecm009.svg" />
        </span>
        <h3 class="fw-bold m-0 text-gray-800">Produtos</h3>
      </div>
      <div
        v-if="this.modal === true"
        class="btn btn-icon btn-sm btn-active-light-primary mt-6"
        data-bs-dismiss="modal"
        @click="this.$emit('fecharProduto', false)"
      >
        <span class="svg-icon svg-icon-1 svg-icon lh-0">
          <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
        </span>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <inline-svg src="media/icons/duotune/general/gen004.svg" />
            </span>
            <input
              v-model="searchValue"
              autocomplete="off"
              type="search"
              @input="onSearch($event.target.value)"
              class="form-control form-control-solid w-250px ps-15"
              placeholder="Pesquisar Produtos"
              id="txtPesquisarProdutos"
              @keydown="keydownPesquisa"
            />
          </div>
        </div>
        <div class="card-toolbar flex-row-fluid justify-content-end gap-5">
          <button
            class="btn btn-sm btn-light-info"
            @click="atualizarPesquisa()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/arrows/arr029.svg" />
            </span>
            Atualizar
          </button>
          <button
            class="btn btn-sm btn-light-danger"
            @click="alterarPesquisaAgrupada()"
            v-if="this.modal === false"
          >
            <div v-if="pesquisaAgrupada">
              <span class="svg-icon svg-icon-1">
                <inline-svg src="media/icons/duotune/general/gen008.svg" />
              </span>
              Agrupado
            </div>
            <div v-else>
              <span class="svg-icon svg-icon-1">
                <inline-svg src="media/icons/duotune/general/gen010.svg" />
              </span>
              Desagrupado
            </div>
          </button>
          <button
            @click="this.$refs.table.exportarExcel()"
            type="button"
            class="btn btn-sm btn-light-primary"
            v-if="!pesquisaAgrupada && this.modal === false"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/arrows/arr078.svg" />
            </span>
            Exportar
          </button>
          <button
            v-if="this.modal === false && this.consultarGrupo"
            type="button"
            class="btn btn-sm btn-light-primary"
            @click="modalGrupos(true)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/general/gen019.svg" /></span
            >Gerenciar grupos
          </button>
          <button
            v-if="this.modal === false && this.consultarKit"
            @click="this.modalKits(true)"
            type="button"
            class="btn btn-sm btn-light-primary svg-icon-white min-w-150px"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/art/art002.svg" /> </span
            >Kits de produtos
          </button>
          <router-link
            v-if="this.adicionar && this.modal === false"
            to="/cadastros/produtos/editar"
            class="btn btn-sm btn-primary"
            id="btnAdicionarProduto"
            ><span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/general/gen041.svg" /></span
            >Adicionar</router-link
          >
          <button
            v-if="this.adicionar && this.modal === true"
            @click="this.$emit('adicionarProduto')"
            class="btn btn-sm btn-primary"
            id="btnAdicionarProdutoModal"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/general/gen041.svg" /></span
            >Adicionar
          </button>
        </div>
      </div>
      <div class="card-body pt-0">
        <template v-if="grupos">
          <div v-if="pesquisaAgrupada">
            <template v-for="(item, index) in grupos" :key="item">
              <div class="card shadow-sm card-bordered mb-4">
                <div
                  class="card-header collapsible cursor-pointer rotate"
                  data-bs-toggle="collapse"
                  v-bind:data-bs-target="'#grupos_collapsible' + index"
                >
                  <h3 class="card-title">{{ item.descricao }}</h3>
                  <div class="card-toolbar rotate-180">
                    <span class="svg-icon svg-icon-1"
                      ><inline-svg src="media/icons/duotune/arrows/arr065.svg"
                    /></span>
                  </div>
                </div>
                <div
                  v-bind:id="'grupos_collapsible' + index"
                  class="collapse show"
                >
                  <div class="card-body">
                    <div v-if="!isLoading" class="table-responsive">
                      <table
                        class="table table-hover table-row-dashed table-row-gray-200 gs-0 gy-4"
                      >
                        <thead class="border-0">
                          <tr>
                            <th class="p-0 w-50px"></th>
                            <th class="p-0 w-50px"></th>
                            <th class="p-0 min-w-150px"></th>
                            <th class="p-0 min-w-140px"></th>
                            <th class="p-0 min-w-110px"></th>
                            <th class="p-0 min-w-50px"></th>
                          </tr>
                        </thead>
                        <draggable
                          v-model="item.Produto"
                          tag="tbody"
                          item-key="id"
                          handle=".handle"
                          @end="onEnd(index)"
                        >
                          <template #item="{ element }">
                            <tr>
                              <td class="align-middle">
                                <div>
                                  <span
                                    class="col svg-icon svg-icon-1 symbol symbol-45px cursor-move handle"
                                    ><inline-svg
                                      src="media/icons/duotune/files/fil001.svg"
                                  /></span>
                                </div>
                              </td>
                              <td class="align-middle">
                                <div
                                  v-if="element.imagem ? element.imagem : ''"
                                  class="symbol symbol-50px me-2"
                                >
                                  <div
                                    class="symbol-label fs-2 fw-bold bg-light-dark"
                                    :style="{
                                      'background-image': `url(${
                                        this.$utils.getUrl() + element.imagem
                                      })`,
                                    }"
                                  ></div>
                                </div>
                                <div v-else class="symbol symbol-50px me-2">
                                  <span class="symbol-label">
                                    <img
                                      src="media/svg/files/blank-image.svg"
                                      class="h-50 align-self-center"
                                      alt=""
                                    />
                                  </span>
                                </div>
                              </td>
                              <td class="align-middle">
                                <div>
                                  <span
                                    class="text-dark fw-bolder text-hover-primary mb-1 fs-4"
                                  >
                                    {{ element.nome }}
                                  </span>
                                  <span class="text-muted fw-bold d-block">
                                    {{ element.descricao }}
                                  </span>
                                </div>
                              </td>
                              <td
                                class="text-end text-muted fw-bold align-middle"
                              >
                                <span class="text-dark fw-bolder mb-1 fs-6">
                                  R$
                                  {{
                                    this.$utils.formatarNumero(element.preco)
                                  }}
                                </span>
                              </td>
                              <td class="text-end align-middle">
                                <span
                                  v-if="element.ativo === '1'"
                                  class="badge badge-light-success"
                                  >Ativo</span
                                >
                                <span v-else class="badge badge-light-danger"
                                  >Desativado</span
                                >
                              </td>
                              <td class="text-end align-middle">
                                <button
                                  class="btn btn-sm btn-light btn-active-light-primary"
                                  data-kt-menu-trigger="click"
                                  data-kt-menu-placement="bottom-end"
                                  data-kt-menu-flip="top-end"
                                >
                                  Ações
                                  <span class="svg-icon svg-icon-5 m-0">
                                    <inline-svg
                                      src="media/icons/duotune/arrows/arr072.svg"
                                    />
                                  </span>
                                </button>
                                <div
                                  v-if="this.editar || this.excluir"
                                  class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
                                  data-kt-menu="true"
                                >
                                  <div
                                    v-if="this.editar"
                                    class="menu-item px-3"
                                  >
                                    <a
                                      @click="editarRegistro(element.id)"
                                      class="menu-link px-3"
                                      >Editar</a
                                    >
                                  </div>
                                  <div
                                    v-if="this.excluir"
                                    class="menu-item px-3"
                                  >
                                    <a
                                      @click="excluirRegistro(element.id)"
                                      class="menu-link px-3"
                                      >Excluír</a
                                    >
                                  </div>
                                  <div
                                    v-if="this.editar && element.ativo === '1'"
                                    class="menu-item px-3"
                                  >
                                    <a
                                      @click="atualizarRegistro(produto)"
                                      class="menu-link px-3"
                                      >Inativar</a
                                    >
                                  </div>
                                  <div
                                    v-if="this.editar && element.ativo === '0'"
                                    class="menu-item px-3"
                                  >
                                    <a
                                      @click="atualizarRegistro(produto)"
                                      class="menu-link px-3"
                                      >Ativar</a
                                    >
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </template>
                        </draggable>
                      </table>
                    </div>
                    <div v-else>
                      <div
                        class="spinner-border text-primary"
                        role="status"
                      ></div>
                      <span class="ms-2">Aguarde, carregando...</span>
                    </div>
                  </div>
                  <div class="card-footer">
                    <a
                      class="btn btn-sm btn-secondary"
                      @click="adicionarProdutoGrupo(item.id)"
                    >
                      <span class="svg-icon svg-icon-1">
                        <inline-svg
                          src="media/icons/duotune/general/gen041.svg" /></span
                      >Adicionar produto
                    </a>
                  </div>
                </div>
              </div>
            </template>

            <div class="row">
              <div
                class="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start"
              >
                <div class="dataTables_length" id="kt_customers_table_length">
                  <label
                    ><select
                      name="kt_customers_table_length"
                      class="form-select form-select-sm form-select-solid"
                      @change="setItemsPerPage"
                      v-model="rowsPage"
                    >
                      <option
                        v-for="pageSize in pageSizes"
                        v-bind:key="pageSize"
                        v-bind:value="pageSize"
                      >
                        {{ pageSize }}
                      </option>
                    </select></label
                  >
                </div>
              </div>
              <div
                class="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end"
              >
                <el-pagination
                  v-model:current-page="pagination.page"
                  @current-change="currentPageChange"
                  :page-size="pagination.rowsPerPage"
                  layout="prev, pager, next"
                  :total="pagination.total"
                  background
                >
                </el-pagination>
              </div>
            </div>
          </div>
          <div v-else>
            <Datatable
              ref="table"
              :table-header="
                this.modal === false ? tableHeader : tableHeaderModal
              "
              :table-data="tableData"
              :table-pagination="tablePagination"
              :page-sizes="pageSizes"
              :enable-items-per-page-dropdown="true"
              :hide-on-single-page="false"
              empty-table-text="Nenhum produto encontrado"
              @checked-rows="checkedProdutos = $event"
              :colors="true"
              @double-click="selecionarRegistro($event)"
              @current-row-selected="currentRow = $event"
              :current-row="currentRow"
            >
              <template v-slot:cell-checkbox="{ row: produto }">
                <div
                  class="form-check form-check-sm form-check-custom form-check-solid"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :value="produto.id"
                    v-model="checkedProdutos"
                  />
                </div>
              </template>
              <template v-slot:cell-codigo="{ row: produto }">
                {{ produto.codigo }}
              </template>
              <template v-slot:cell-imagem="{ row: produto }">
                <div v-if="produto.imagem" class="symbol symbol-50px">
                  <div
                    class="symbol-label fs-2 fw-bold bg-light-dark"
                    :style="{
                      'background-image': `url(${
                        this.$utils.getUrl() + produto.imagem
                      })`,
                    }"
                  ></div>
                </div>
                <div v-else class="symbol symbol-50px">
                  <div :class="['symbol-label fs-2 fw-bold ' + produto.color]">
                    {{
                      produto.nome
                        ? produto.nome.substring(0, 1).toUpperCase()
                        : ""
                    }}
                  </div>
                </div>
              </template>
              <template v-slot:cell-nome="{ row: produto }">
                <div class="align-middle">
                  <div>
                    <span class="text-dark text-hover-primary mb-1 fs-4">
                      {{ produto.nome }}
                    </span>
                    <span class="text-muted fw-bold d-block">
                      {{ produto.descricao }}
                    </span>
                  </div>
                </div>
              </template>
              <template v-slot:cell-quantidade="{ row: produto }">
                {{ this.$utils.formatarNumero(produto.quantidade) }}
              </template>
              <template v-slot:cell-ean="{ row: produto }">
                {{ produto.ean }}
              </template>
              <template v-slot:cell-ativo="{ row: produto }">
                <span
                  v-if="produto.ativo === '1'"
                  class="badge badge-light-success"
                  >Ativo</span
                >
                <span v-else class="badge badge-light-danger"
                  >Indisponível</span
                >
              </template>
              <template v-slot:cell-preco="{ row: produto }">
                {{ this.$utils.formatarNumero(produto.preco) }}
              </template>
              <template v-slot:cell-preco_promocao="{ row: produto }">
                {{ this.$utils.formatarNumero(produto.preco_promocao) }}
              </template>
              <template v-slot:cell-acoes="{ row: produto }">
                <div :class="[this.modal === true && 'min-w-225px']">
                  <button
                    v-if="this.modal === true"
                    class="btn btn-sm btn-light-primary me-2"
                    @click="selecionarRegistro(produto)"
                  >
                    Selecionar
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-light btn-active-light-primary ms-2 my-2"
                    data-kt-menu-trigger="click"
                    data-kt-menu-placement="bottom-end"
                    data-kt-menu-flip="top-end"
                  >
                    Ações
                    <span class="svg-icon svg-icon-5 m-0">
                      <inline-svg src="media/icons/duotune/arrows/arr072.svg" />
                    </span>
                  </button>
                  <div
                    v-if="this.editar || this.excluir"
                    class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
                    data-kt-menu="true"
                  >
                    <div
                      v-if="this.editar && this.modal === false"
                      class="menu-item px-3"
                    >
                      <a
                        @click="editarRegistro(produto.id)"
                        class="menu-link px-3"
                        >Editar</a
                      >
                    </div>
                    <div
                      v-if="this.editar && this.modal === true"
                      class="menu-item px-3"
                    >
                      <a
                        @click="this.$emit('editarProduto', produto.id)"
                        class="menu-link px-3"
                        >Editar</a
                      >
                    </div>
                    <div v-if="this.excluir" class="menu-item px-3">
                      <a
                        @click="excluirRegistro(produto.id)"
                        class="menu-link px-3"
                        >Excluír</a
                      >
                    </div>
                    <div
                      v-if="this.editar && produto.ativo === '1'"
                      class="menu-item px-3"
                    >
                      <a
                        @click="atualizarRegistro(produto)"
                        class="menu-link px-3"
                        >Inativar</a
                      >
                    </div>
                    <div
                      v-if="this.editar && produto.ativo === '0'"
                      class="menu-item px-3"
                    >
                      <a
                        @click="atualizarRegistro(produto)"
                        class="menu-link px-3"
                        >Ativar</a
                      >
                    </div>
                  </div>
                </div>
              </template>
            </Datatable>
          </div>
        </template>
        <template v-else>
          <div></div>
        </template>
      </div>
      <div class="card-body pt-0"></div>
    </div>
  </div>
  <GruposModal
    v-if="exibirGrupos"
    @exibirModalGrupo="modalGrupos"
  ></GruposModal>
  <component
    :is="modalComponent"
    v-if="exibirKits"
    @exibirModalKits="modalKits"
    @selecionarKit="selecionarKit"
  ></component>
</template>

<script>
import { ref, markRaw } from "vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { mapState } from "vuex";
import draggable from "vuedraggable";
import { MenuComponent } from "@/assets/ts/components";
import GruposModal from "../grupos/GruposModal.vue";
//import KitsModal from "../produtos/KitsModal.vue";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import { useToast } from "vue-toastification";
const toast = useToast();
import { getOrCreateInstanceModal } from "@/core/helpers/dom";

export default {
  emits: [
    "selecionarProduto",
    "fecharProduto",
    "adicionarProduto",
    "editarProduto",
  ],
  components: {
    GruposModal,
    Datatable,
    draggable, //KitsModal
  },
  props: {
    modal: { type: Boolean, required: false, default: false },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    selecionarKit(kit) {
      console.log(kit);
    },
    modalKits(exibir) {
      this.exibirKits = exibir;
      import("@/views/produtos/KitsModal.vue").then((module) => {
        this.modalComponent = markRaw(module.default);
      });
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal(
            "kt_modal_kits_consultar",
            /*open*/ () => {
              this.$utils.requestFocus("txtPesquisarKits");
            },
            /*close*/ () => {
              this.modalKits(false);
            }
          );
        }, 100);
      }
    },
    modalGrupos(exibir) {
      this.exibirGrupos = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_grupos_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarGrupos");
          },
          /*close*/ () => {
            this.modalGrupos(false);
          }
        );
      }
    },
    async carregarGrupos() {
      if (this.pesquisaAgrupada) {
        this.isLoading = true;
        var page = (this.pagination.page - 1) * this.pagination.rowsPerPage;

        var filtro =
          "?&$count=true&$skip=" +
          page +
          "&$top=" +
          this.pagination.rowsPerPage +
          "&$expand=produto($select=id,imagem,nome,descricao,preco,ativo;$orderby=ordem,nome asc)&$orderby=descricao";

        if (this.filterOData !== "" && this.filterOData !== undefined) {
          filtro += this.filterOData;
        }

        try {
          var ret = await this.$store.dispatch("grupo/getGrupoOData", filtro);
          if (ret.value !== null && ret.value.length > 0) {
            this.pagination.total = ret["@odata.count"];
            this.grupos = ret.value;
            setTimeout(MenuComponent.reinitialization, 300);
          }
        } catch (error) {
          if (error !== "") {
            console.log(error);
            await this.$swal.showErrorAlert(error.Message);
          }
        }
        this.isLoading = false;
      }
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=contains(nome, '" +
          pesquisa +
          "') or contains(descricao, '" +
          pesquisa +
          "') or contains(ean, '" +
          pesquisa +
          "') or contains(cod_referencia, '" +
          pesquisa +
          "')";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData + " or codigo eq " + pesquisa;
        }
        this.pesquisaAgrupada = false;
      } else {
        this.tableData.filterOData = "";
      }
    },
    loadData() {
      this.tableData.search = "";
      this.tablePagination.page = 1;
      this.tablePagination.rowsPerPage = 5;
      this.$refs.table.setRowsPage(5);
      this.tableData.filterOData = "";
      this.$refs.table.load();
    },
    async atualizarPesquisa() {
      this.filterOData = "";
      this.searchValue = "";
      this.pagination.page = 1;

      if (this.pesquisaAgrupada) {
        await this.carregarGrupos();
      } else {
        this.loadData();
      }
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.Produto.Incluir") {
            this.adicionar = true;
          }
          if (element.regra === "Permitir.Produto.Alterar") {
            this.editar = true;
          }
          if (element.regra === "Permitir.Produto.Excluir") {
            this.excluir = true;
          }

          if (element.regra === "Permitir.Grupo.Consultar") {
            this.consultarGrupo = true;
          }

          if (element.regra === "Permitir.Kit.Consultar") {
            this.consultarKit = true;
          }
        });
      }
    },
    editarRegistro(id) {
      this.$router.push("/cadastros/produtos/editar/" + id);
    },
    async excluirRegistro(id) {
      await this.$swal.showQuestionAlert(
        "Deseja remover o registro?",
        async (alert) => {
          if (alert.isConfirmed) {
            try {
              var ret = await this.$store.dispatch("produto/deleteProduto", id);
              if (ret.Success === true) {
                if (this.pesquisaAgrupada) {
                  await this.carregarGrupos();
                } else {
                  this.$refs.table.load();
                }

                toast.success("Produto excluído com sucesso!", {
                  timeout: 3000,
                });
              }
            } catch (error) {
              await this.$swal.showErrorAlert(error.Message);
            }
          }
        }
      );
    },
    adicionarProdutoGrupo(id) {
      this.$router.push("/cadastros/produtos/editar?grupo=" + id);
    },
    async currentPageChange(val) {
      this.pagination.page = val;
      await this.carregarGrupos();
    },
    async setItemsPerPage(event) {
      if (this.$utils.isNumber(event.target.value)) {
        this.pagination.rowsPerPage = parseInt(event.target.value);
        this.rowsPage = this.pagination.rowsPerPage;
      } else {
        this.pagination.rowsPerPage = parseInt(this.pagination.total);
      }
      this.pagination.page = 1;
      await this.carregarGrupos();
    },
    async alterarPesquisaAgrupada() {
      this.pesquisaAgrupada = !this.pesquisaAgrupada;
      await this.carregarGrupos();
    },
    selecionarRegistro(produto) {
      this.$emit("selecionarProduto", produto);
    },
    async atualizarRegistro(produto) {
      this.isLoading = true;
      try {
        var ret = await this.$store.dispatch("produto/getProduto", produto.id);
        if (ret.Success === true) {
          if (ret.Data !== null) {
            var p = ret.Data;
            if (p.ativo === "1") {
              p.ativo = "0";
            } else {
              p.ativo = "1";
            }
            var formData = this.$utils.convertModelToFormData(p);

            try {
              var retPut = await this.$store.dispatch(
                "produto/putProduto",
                formData
              );
              if (retPut.Success === true) {
                if (this.pesquisaAgrupada === true) {
                  await this.carregarGrupos();
                } else {
                  this.$refs.table.load();
                }
              }
            } catch (error) {
              await this.$swal.showErrorAlert(error.Message);
            }
          }
        }
      } catch (error) {
        await this.$swal.showErrorAlert(error.Message);
      }
      this.isLoading = false;
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    async onEnd(index) {
      this.isLoading = true;
      try {
        var ordem = 0;
        for (var key in this.grupos[index].Produto) {
          var item = this.grupos[index].Produto[key];
          try {
            var ret = await this.$store.dispatch("produto/getProduto", item.id);
            if (ret.Success == true) {
              var produto = ret.Data;
              produto.ordem = ordem;
              var formData = this.$utils.convertModelToFormData(produto);
              try {
                await this.$store.dispatch("produto/putProduto", formData);
              } catch (error) {
                console.log(error);
              }
            }
            ordem += 1;
          } catch (error) {
            console.log(error);
          }
        }
        setTimeout(MenuComponent.reinitialization, 300);
      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },
    async keydownPesquisa(e) {
      if (e.key === "ArrowUp") {
        e.preventDefault();
        e.stopPropagation();
        this.currentRow -= 1;
        if (this.currentRow < 0) {
          this.currentRow = 0;
        }
        this.$refs.table.setCurrentRow(this.currentRow);
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        e.stopPropagation();
        this.currentRow += 1;
        this.$refs.table.setCurrentRow(this.currentRow);
      } else if (e.key === "Enter") {
        e.preventDefault();
        e.stopPropagation();
        let registro = this.$refs.table.getCurrentItemIndex(this.currentRow);
        this.selecionarRegistro(registro);
      }
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.verificarRestricoes();
    await this.carregarGrupos();
    if (this.modal === true) {
      this.pesquisaAgrupada = false;
    }
    this.$utils.requestFocus("txtPesquisarProdutos");
  },
  data() {
    return {
      consultarKit: false,
      consultarGrupo: false,
      modalComponent: null,
      exibirKits: false,
      exibirGrupos: false,
      isLoading: false,
      grupos: [],
      adicionar: false,
      editar: false,
      excluir: false,
      filterOdata: "",
      searchValue: "",
      pagination: {
        page: 1,
        rowsPerPage: 5,
        total: 0,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "Todos"],
      rowsPage: 5,
      pesquisaAgrupada: false,
      currentRow: 0,
      tableHeader: [
        {
          name: "Código",
          key: "codigo",
          sortable: true,
        },
        {
          key: "imagem",
          sortable: false,
        },
        {
          name: "Nome",
          key: "nome",
          sortable: true,
        },
        {
          name: "Quantidade",
          key: "quantidade",
          sortable: true,
        },
        {
          name: "Situação",
          key: "ativo",
          sortable: true,
        },
        {
          name: "Preço",
          key: "preco",
          sortable: true,
        },
        {
          name: "Preço promoção",
          key: "preco_promocao",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableHeaderModal: [
        {
          name: "Código",
          key: "codigo",
          sortable: true,
        },
        {
          key: "imagem",
          sortable: false,
        },
        {
          name: "Nome",
          key: "nome",
          sortable: true,
        },
        {
          name: "Quantidade",
          key: "quantidade",
          sortable: true,
        },
        {
          name: "Situação",
          key: "ativo",
          sortable: true,
        },
        {
          name: "Preço",
          key: "preco",
          sortable: true,
        },
        {
          name: "Preço promoção",
          key: "preco_promocao",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableData: {
        store: "produto/getProdutoOData",
        selectOData:
          "?$select=id,codigo,nome,descricao,ativo,guid,cod_referencia,ean,imagem,preco,preco_promocao,quantidade",
        filterOData: "",
        search: "",
        defaultSort: "codigo asc",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 5,
      },
      checkedProdutos: [],
    };
  },
};
</script>

<style></style>
